import React from 'react';

//content
import BackgroundImg from './../js/background_img/background_img';
import Header from './../js/header/header';
import Hero from './../js/hero/hero';
import Features from './../js/features/features';
import Partners from './../js/partners/partners';
import DidYouKnow from './../js/did_you_know/did_you_know';
import Footer from './../js/footer/footer';
import FooterLast from './../js/footer_last/footer_last';

//anim
import Bubbles from './../js/bubbles/bubbles';
import FishA from './../js/fish_a/fish_a';
import FishB from './../js/fish_b/fish_b';
import FishC from './../js/fish_c/fish_c';
import FishD from './../js/fish_d/fish_d';
import FishE from './../js/fish_e/fish_e';
import FishF from './../js/fish_f/fish_f';
import FishG from './../js/fish_g/fish_g';
import FishH from './../js/fish_h/fish_h';
import FishI from './../js/fish_i/fish_i';
import FishJ from './../js/fish_j/fish_j';
import FishK from './../js/fish_k/fish_k';
import Octopus from './../js/octopus/octopus';
import ShipSparkles from './../js/sunken_ship_sparkles/sunken_ship_sparkles';

const Home = () => {
  return (
    <React.Fragment>
      <FishA />
      <FishB />
      <BackgroundImg />
      <Bubbles />
      <FishC />
      <FishD />
      <FishE />
      <FishF />
      <FishG />
      <FishH />
      <FishI />
      <FishJ />
      <FishK />

      <ShipSparkles />
      <Header />
      <Hero />
      <Features />
      <Partners />
      <DidYouKnow />
      <Octopus />
      <Footer />

      <FooterLast />
    </React.Fragment>
  );
};

export default Home;
